import React, { useCallback } from 'react'
import { message } from 'antd'
import { useDispatch } from 'react-redux'
import { createPaymentAction } from '../../../store/payment'
import ApplicationPaymentFormModal from './ApplicationPaymentFormModal'

const messageKey = 'add_new_payment'

const AddApplicationPaymentModal = ({ showModal, application, onFinish, onCancel }) => {
  const dispatch = useDispatch()

  const onFinishAction = useCallback(
    async (data) => {
      const newPayment = await dispatch(createPaymentAction({ application, ...data })).unwrap()
      const { id, paid } = newPayment?.result
      message.success({
        key: messageKey,
        content: `Платёж № ${id} на ${paid} р. добавлен успешно`,
      })
      onFinish()
    },
    [application, onFinish, dispatch]
  )

  const onErrorAction = useCallback(({ name, status, message: errorMessage }) => {
    message.error({
      key: messageKey,
      content: `Ошибка (${name}, статус: ${status}): '${errorMessage}' `,
    })
  }, [])

  return (
    <ApplicationPaymentFormModal
      showModal={showModal}
      onFinish={onFinishAction}
      onError={onErrorAction}
      onCancel={onCancel}
    />
  )
}

export default AddApplicationPaymentModal
